import React from 'react';
import { X } from 'lucide-react';

export default function PoliticaPrivacidadModal({ onClose }) {
  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-content animate-scale-in" style={{ maxWidth: 650, padding: '2.5rem' }}>
        <header className="modal-header">
          <div>
            <h2 style={{ margin: 0 }}>Política de Privacidad</h2>
            <p className="text-muted" style={{ fontSize: '0.9rem' }}>{import.meta.env.VITE_CBR_NAME || "CBR San Carlos"} · PrismAgen</p>
          </div>
          <button className="modal-close" onClick={onClose}><X size={20} /></button>
        </header>

        <div style={{
          maxHeight: '450px', overflowY: 'auto', padding: '1.5rem',
          background: '#f8fafc', borderRadius: '12px', border: '1px solid var(--border-color)',
          marginBottom: '1.5rem', fontSize: '0.9rem', lineHeight: '1.6', color: 'var(--primary-dark)'
        }}>
          <h3 style={{ fontSize: '1.1rem', color: 'var(--primary-dark)' }}>POLÍTICA DE PRIVACIDAD Y PROTECCIÓN DE DATOS PERSONALES</h3>
          <p><strong style={{ color: 'var(--primary)' }}>1. Marco Legal Aplicable</strong><br /> La presente Política de Privacidad se rige por la legislación de la República de Chile, en particular por la Ley N° 19.628 sobre Protección de la Vida Privada.</p>

          <p><strong style={{ color: 'var(--primary)' }}>2. Responsables del Tratamiento</strong><br /> Los responsables del tratamiento son el Conservador de Bienes Raíces de {import.meta.env.VITE_CBR_CITY || "SAN CARLOS"} y PrismAgen.</p>

          <p><strong style={{ color: 'var(--primary)' }}>3. Datos Recolectados y Finalidad</strong><br /> La plataforma recolecta datos con el fin exclusivo de gestionar solicitudes registrales y comunicación con los usuarios.</p>

          <p><strong style={{ color: 'var(--primary)' }}>4. Comunicación de Datos</strong><br /> Sus datos podrían ser validados o comunicados a entidades como el SII o Notarías bajo el marco legal del CBR.</p>

          <p><strong style={{ color: 'var(--primary)' }}>5. Seguridad de la Información</strong><br /> Se utilizan protocolos SSL y bases de datos encriptadas (Encryption at Rest) en infraestructura AWS.</p>

          <p><strong style={{ color: 'var(--primary)' }}>6. Almacenamiento</strong><br /> Los datos son almacenados en servidores de Amazon Web Services (AWS), lo que puede implicar transferencia internacional de datos.</p>

          <p><strong style={{ color: 'var(--primary)' }}>7. Derechos ARCO</strong><br /> Puede ejercer sus derechos de acceso, rectificación o cancelación enviando un correo a <strong style={{ color: 'var(--primary)' }}>contacto@prismagen.com</strong>.</p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
          <button className="btn btn-primary" onClick={onClose} style={{ padding: '0.75rem 2rem' }}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
